var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg150Truck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "150---Schedule-Transit",
    fillRule: "nonzero",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m39 13v30h-34c-2.209139 0-4-1.790861-4-4v-26c0-3.3137085 2.6862915-6 6-6h26c3.3137085 0 6 2.6862915 6 6z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m33 7h-3c3.3137085 0 6 2.6862915 6 6v30h3v-30c0-3.3137085-2.6862915-6-6-6z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 43v7c0 1.6568542-1.3431458 3-3 3h-3.09c-.4853307-2.8857455-2.9837271-4.9990438-5.91-4.9990438s-5.4246693 2.1132983-5.91 4.9990438h-19.18c-.4853307-2.8857455-2.9837271-4.9990438-5.91-4.9990438s-5.4246693 2.1132983-5.91 4.9990438h-2.09c-1.65685425 0-3-1.3431458-3-3v-7z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m56 43v7c0 1.6568542-1.3431458 3-3 3h3c1.6568542 0 3-1.3431458 3-3v-7z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 37v6h-20v-24h9.02c.6189933.0014878 1.2024148.289506 1.58.78l2.45 3.18-.05.04h-7c-1.1032019.0032948-1.9967052.8967981-2 2v10c.0032948 1.1032019.8967981 1.9967052 2 2z",
    fill: "#ffe7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m59 32.68v4.32h-14c-1.1032019-.0032948-1.9967052-.8967981-2-2v-10c.0032948-1.1032019.8967981-1.9967052 2-2h7l.05-.04 6.54 8.5c.2635216.3524071.4072107.7799697.41 1.22z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m22 54c0 3.3137085-2.6862915 6-6 6s-6-2.6862915-6-6c-.00072051-.3353876.0294064-.6701307.09-1 .4853307-2.8857455 2.9837271-4.9990438 5.91-4.9990438s5.4246693 2.1132983 5.91 4.9990438c.0605936.3298693.0907205.6646124.09 1z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 54,
    fill: "#ffc9cc",
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m53 54c-.0000001 3.3137084-2.6862916 5.9999998-6 5.9999998s-5.9999999-2.6862914-6-5.9999998c-.0007205-.3353876.0294064-.6701307.09-1 .4853307-2.8857455 2.9837271-4.9990438 5.91-4.9990438s5.4246693 2.1132983 5.91 4.9990438c.0605936.3298693.0907205.6646124.09 1z",
    fill: "#ffe0e2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 47,
    cy: 54,
    fill: "#ffc9cc",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 17,
    fill: "#ffe0e2",
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 17,
    fill: "#ffe7e8",
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m16 6c-.5020055.00396839-1.0031606.04205618-1.5.114 5.44307.74317391 9.5006713 5.3924293 9.5006713 10.886s-4.0576013 10.1428261-9.5006713 10.886c4.0710962.5639443 8.1168227-1.1897596 10.4884456-4.5464339 2.3716229-3.3566742 2.6731269-7.7558191.7816417-11.4046739-1.8914852-3.64885477-5.6601181-5.93813115-9.7700873-5.9348922z",
    fill: "#ffc9cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m10.11 52.86c-.0122557.045696-.0189706.0927002-.02.14h-2.09c-1.65685425 0-3-1.3431458-3-3v-7c-2.209139 0-4-1.790861-4-4v-26c.00110721-2.2527257 1.26396671-4.31500997 3.27-5.34 3.17844705-3.99388737 8.1726194-6.09332436 13.25-5.57-4.0296964.39292194-7.72798224 2.40262461-10.25 5.57-2.00603329 1.02499003-3.26889279 3.0872743-3.27 5.34v26c0 2.209139 1.790861 4 4 4v7c-.006305 1.3149732.85172309 2.4779876 2.11 2.86z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m0 31h2v8h-2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ff414c"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m50.393 19.17c-.5699462-.7351583-1.4467926-1.1667571-2.377-1.17h-8.016v-5c-.0049584-3.86393756-3.1360624-6.99504164-7-7h-5.411c-4.4990655-4.75769549-11.4455154-6.28896023-17.527951-3.86383458-6.08243561 2.42512564-10.06969987 8.31576748-10.061049 14.86383458v14c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-6.271c2.84502497 5.1622814 8.2990934 8.3410438 14.1930356 8.272043 5.8939422-.0690007 11.2720981-3.3745768 13.9954895-8.602048s2.3504402-11.5292408-.9705251-16.398995h3.782c2.7600532.00330612 4.9966939 2.2399468 5 5v29h-33c-1.65685425 0-3-1.3431458-3-3 0-.5522847-.44771525-1-1-1s-1 .4477153-1 1c.00299829 2.3751008 1.6735832 4.4215673 4 4.9v6.1c0 2.209139 1.790861 4 4 4h1c0 3.8659932 3.1340068 7 7 7s7-3.1340068 7-7h17c0 3.8659932 3.1340068 7 7 7s7-3.1340068 7-7h2c2.209139 0 4-1.790861 4-4v-17.319c-.0009628-.6614115-.2195361-1.3041296-.622-1.829zm-34.393 11.83c-7.7319865 0-14-6.2680135-14-14s6.2680135-14 14-14 14 6.2680135 14 14c-.0082673 7.7285595-6.2714405 13.9917327-14 14zm42 1.681.0000003 3.319h-13.0000003c-.5522847 0-1-.4477153-1-1v-10c0-.5522847.4477153-1 1-1h6.585l6.208 8.071c.1343941.1749353.2071716.3894006.207.61zm-42 26.319c-2.7614237 0-5-2.2385763-5-5s2.2385763-5 5-5 5 2.2385763 5 5c-.0033061 2.7600532-2.2399468 4.9966939-5 5zm31 0c-2.7614237 0-5-2.2385763-5-5s2.2385763-5 5-5 5 2.2385763 5 5c-.0033061 2.7600532-2.2399468 4.9966939-5 5zm9-7h-2.3c-.8935021-2.952905-3.6148754-4.9726865-6.7-4.9726865s-5.8064979 2.0197815-6.7 4.9726865h-17.595c-.8907752-2.9570695-3.6141768-4.9809671-6.7025-4.9809671s-5.8117248 2.0238976-6.7025 4.9809671h-1.3c-1.1045695 0-2-.8954305-2-2v-6h43c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-9v-22h8.016c.3099872.0010333.6021874.1449198.792.39l1.238 1.61h-5.046c-1.6568542 0-3 1.3431458-3 3v10c0 1.6568542 1.3431458 3 3 3h13v12c0 1.1045695-.8954305 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m16 51c-1.6568542 0-3 1.3431458-3 3s1.3431458 3 3 3 3-1.3431458 3-3-1.3431458-3-3-3zm0 4c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1 1 .4477153 1 1-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 51c-1.2133867 0-2.3072956.7309265-2.7716386 1.8519497s-.2076757 2.4113767.6503183 3.2693706c.8579939.857994 2.1483474 1.1146613 3.2693706.6503183s1.8519497-1.5582519 1.8519497-2.7716386c0-1.6568542-1.3431458-3-3-3zm0 4c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1 1 .4477153 1 1-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m55 42h-2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 26c-.5522847 0-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 31c-.5522847 0-1 .4477153-1 1v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 48h-2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m38 48h-7c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h7c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m13 21c.2651948-.0000566.5195073-.1054506.707-.293l3.006-3.007c.1875494-.1874927.2929434-.4418052.293-.707v-6.993c0-.55228475-.4477153-1-1-1s-1 .44771525-1 1v6.578l-2.713 2.715c-.2859079.2859943-.3714219.7160366-.216678 1.0896546.1547439.3736179.5192821.6172591.923678.6173454z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m15.006 23v1c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-1c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m23 17.992c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-1c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m10 15.992h-1c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h1c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m16 5c-.7195831-.00012305-1.4377494.06379576-2.146.191-.351728.06341464-.6429067.30965682-.763852.64596951-.1209453.33631268-.0532827.71160197.1775.98450001s.589624.40194513.941352.33853048c.5910677-.10638631 1.1904344-.15993108 1.791-.16 4.3809886.00346986 8.2487773 2.86036404 9.5401395 7.0467058 1.2913622 4.1863417-.2949164 8.7256538-3.9126541 11.1964933-3.6177376 2.4708395-8.4230857 2.2968754-11.8526876-.4290931-3.42960186-2.7259686-4.68349216-7.368101-3.0927978-11.450106.13004468-.3329715.07257273-.7100279-.15076674-.9891357s-.57861587-.4178638-.93200001-.364c-.35338415.0538638-.65118858.2921642-.78123325.6251357-1.91384049 4.9022872-.41023942 10.4795371 3.7084174 13.7554906 4.1186568 3.2759536 9.8912096 3.4861105 14.2371775.518322 4.345968-2.9677885 6.2511442-8.4209377 4.6988454-13.449414-1.5522989-5.02847626-6.1998171-8.45879789-11.4624403-8.4603986z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m8 10.45c.27556511.0001098.53896234-.1134984.728-.314.54407681-.57614933 1.15430454-1.08601507 1.818-1.519.4628146-.30154748.5935475-.92118538.292-1.38399999s-.92118538-.59354747-1.384-.29200001c-.79668804.51986566-1.52910674 1.13211668-2.182 1.824-.27315444.2905178-.34759855.71555251-.1894428 1.08161357.15815575.36606103.51867734.60316993.9174428.60338643z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg150Truck);
export default __webpack_public_path__ + "static/media/150-truck.35c464a45042a4c853d068edb0d86f80.svg";
export { ForwardRef as ReactComponent };